const RENTALCAR_UPDATED = (state, RentalCar) => {
  state.RentalCar = RentalCar
}

export default {
  RENTALCAR_UPDATED
}
